/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, OnInit, Input, Injectable } from "@angular/core";
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BaseConcept } from "../../../concept/base";
import { ResourceTable } from "../../../service/resource-table.service";
import { AsyncPipe } from "@angular/common";
import { Observable, combineLatest, map } from "rxjs";
import { MatSelectModule } from "@angular/material/select";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
    override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0) {
            return "0 of 0";
        }
        const isLengthValid = length && length !== Infinity;
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} of ${isLengthValid ? length : "many"}`;
    };
}

@Component({
    selector: "tp-table-paginator",
    templateUrl: "./table-paginator.component.html",
    styleUrls: ["./table-paginator.component.scss"],
    imports: [MatPaginatorModule, AsyncPipe],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }],
})
export class TablePaginatorComponent<ENTITY extends BaseConcept> {
    readonly itemsPerPageOptions = [10, 20, 30, 50];
    @Input({ required: true }) table!: ResourceTable<ENTITY, string>;

    constructor() {}

    page(pageEvent: PageEvent) {
        const offset = pageEvent.pageIndex * pageEvent.pageSize;
        const limit = pageEvent.pageSize;
        this.table.pagination$.next({ offset, limit });
    }
}
